import React from 'react';
import SEO from "../components/seo";
import Layout from "../components/layout";
import { Banner } from '../components/Banner';

//Images
import homeBanner from '../images/homeBanner.jpg';

const styles = {
  backgroundImage: `url(${homeBanner})`,
}


const Cancellation = () => {
  return(
    <Layout>
    <SEO title="Warranty" keywords={[`Garden`, `Vertical Garden`, `Office garden`]} />

    <section className="banner col-md-12" style={ styles }>
      <Banner heading="garden design for urban spaces" info="We design amazing gardens" />
    </section>

    <section className="section">
      <div className="container">
        <div className="text-center">
          <h2 className="heading heading--lg text-uppercase">warranty</h2>
        </div>
      </div>
    </section>

    <section>
      <div className="container">
        <ul>
            <li className="mb-5">
                <h3 className="heading heading--lg text-capitalize">balcony garden</h3>
                <p className="info info--black ml-md-4">Standard warranty of 1yr on all products manufactured by Mycloudforest. For other products, product specific standard warranty prevails which will be informed and provided. We do not provide any warranty on plants. However, we provide maintenance service for our clients which you can opt at any time. Please refer to the maintenance section on the website for further details. </p>
            </li>
            <li className="mb-5">
                <h3 className="heading heading--lg text-capitalize">artificial grass</h3>
                <p className="info info--black ml-md-4">7 yrs warranty on any product manufacturing issue or sun fading.</p>
            </li>
            <li className="mb-5">
                <h3 className="heading heading--lg text-capitalize">vertical garden</h3>
                <p className="info info--black ml-md-4">1 year warranty on base structure and pot system for vertical garden. No warranty on plants. However, we provide maintenance service for our clients which you can opt at any time. Please refer to the maintenance section on the website for further details.</p>
            </li>
            <li className="mb-5">
                <h3 className="heading heading--lg text-capitalize">customized projects(Terrace Garden/Landscaping)</h3>
                <p className="info info--black ml-md-4">Standard warranty of 1yr on all products manufactured by Mycloudforest. For other products, product specific standard warranty prevails which will be informed and provided. We do not provide any warranty on plants. However, we provide maintenance service for our clients which you can opt at any time. Please refer to the maintenance section on the website for further details.</p>
            </li>
        </ul>
            
      </div>
    </section>
  </Layout>
  );
}

export default Cancellation;